import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHTituloDel = async (credentials, data) => {
    const body = {
        service: "RNHTituloDel",
        params: {
            rnhTituloId: data?.id || null,
            rnhTituloVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
